import { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const Navbar = () => {
  const { user, profile, signOut } = useAuth();
  const [isScrolled, setIsScrolled] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [cartCount] = useState(3);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut();
      if (window.REACT_APP_NAVIGATE) {
        window.REACT_APP_NAVIGATE('/');
      } else {
        console.warn('Navigation function not available');
      }
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const navigate = (path) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    } else {
      console.warn('Navigation function not available');
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              window.REACT_APP_NAVIGATE('/');
            }}
            className="flex items-center gap-2 cursor-pointer"
          >
            <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-pink-500 to-purple-600 rounded-lg">
              <i className="ri-shopping-bag-line text-2xl text-white"></i>
            </div>
            <span className="text-xl font-display font-bold text-gray-900">ShopHub</span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                window.REACT_APP_NAVIGATE('/');
              }}
              className="text-gray-700 hover:text-pink-600 transition-colors cursor-pointer"
            >
              Ana Sayfa
            </a>
            {user && (
              <>
                <a
                  href="/favorilerim"
                  onClick={(e) => {
                    e.preventDefault();
                    window.REACT_APP_NAVIGATE('/favorilerim');
                  }}
                  className="text-gray-700 hover:text-pink-600 transition-colors cursor-pointer flex items-center gap-1"
                >
                  <i className="ri-heart-line"></i>
                  Favoriler
                </a>
                <a
                  href="/siparislerim"
                  onClick={(e) => {
                    e.preventDefault();
                    window.REACT_APP_NAVIGATE('/siparislerim');
                  }}
                  className="text-gray-700 hover:text-pink-600 transition-colors cursor-pointer flex items-center gap-1"
                >
                  <i className="ri-shopping-bag-line"></i>
                  Siparişlerim
                </a>
                <a
                  href="/sepet"
                  onClick={(e) => {
                    e.preventDefault();
                    window.REACT_APP_NAVIGATE('/sepet');
                  }}
                  className="relative text-gray-700 hover:text-pink-600 transition-colors cursor-pointer"
                >
                  <i className="ri-shopping-cart-line text-2xl"></i>
                </a>
              </>
            )}
          </div>

          {/* User Menu */}
          <div className="flex items-center gap-4">
            {user ? (
              <>
                <button
                  onClick={() => window.REACT_APP_NAVIGATE('/yonetici')}
                  className="hidden md:block px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg hover:from-pink-600 hover:to-purple-700 transition-all whitespace-nowrap cursor-pointer"
                >
                  Yönetici
                </button>
                <button
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  className="relative w-10 h-10 flex items-center justify-center bg-gradient-to-br from-pink-500 to-purple-600 rounded-full text-white font-semibold cursor-pointer"
                >
                  {user.email?.[0].toUpperCase()}
                </button>

                {showUserMenu && (
                  <div className="absolute top-16 right-4 bg-white rounded-xl shadow-xl py-2 min-w-[200px]">
                    <a
                      href="/profil"
                      onClick={(e) => {
                        e.preventDefault();
                        window.REACT_APP_NAVIGATE('/profil');
                        setShowUserMenu(false);
                      }}
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer"
                    >
                      <i className="ri-user-line mr-2"></i>
                      Profilim
                    </a>
                    <a
                      href="/siparislerim"
                      onClick={(e) => {
                        e.preventDefault();
                        window.REACT_APP_NAVIGATE('/siparislerim');
                        setShowUserMenu(false);
                      }}
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer md:hidden"
                    >
                      <i className="ri-shopping-bag-line mr-2"></i>
                      Siparişlerim
                    </a>
                    <a
                      href="/favorilerim"
                      onClick={(e) => {
                        e.preventDefault();
                        window.REACT_APP_NAVIGATE('/favorilerim');
                        setShowUserMenu(false);
                      }}
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer md:hidden"
                    >
                      <i className="ri-heart-line mr-2"></i>
                      Favorilerim
                    </a>
                    <a
                      href="/sepet"
                      onClick={(e) => {
                        e.preventDefault();
                        window.REACT_APP_NAVIGATE('/sepet');
                        setShowUserMenu(false);
                      }}
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer md:hidden"
                    >
                      <i className="ri-shopping-cart-line mr-2"></i>
                      Sepetim
                    </a>
                    <a
                      href="/ayarlar"
                      onClick={(e) => {
                        e.preventDefault();
                        window.REACT_APP_NAVIGATE('/ayarlar');
                        setShowUserMenu(false);
                      }}
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer"
                    >
                      <i className="ri-settings-line mr-2"></i>
                      Ayarlar
                    </a>
                    <button
                      onClick={handleSignOut}
                      className="w-full text-left px-4 py-2 text-red-600 hover:bg-red-50 cursor-pointer"
                    >
                      <i className="ri-logout-box-line mr-2"></i>
                      Çıkış Yap
                    </button>
                  </div>
                )}
              </>
            ) : (
              <button
                onClick={() => window.REACT_APP_NAVIGATE('/kayit')}
                className="px-6 py-2 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg hover:from-pink-600 hover:to-purple-700 transition-all whitespace-nowrap cursor-pointer"
              >
                Giriş Yap
              </button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
